/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Header Navigation
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */


// Open and close the subnav
// Give class to body when subnav is open
function toggleItem(elem) {
    for (var i = 0; i < elem.length; i++) {
        elem[i].addEventListener('click', function(e) {
            var current = this;
            var body = document.querySelector('body');

            for (var q = 0; q < elem.length; q++) {
                if (current !== elem[q]) {
                    elem[q].classList.remove('is--open');
                } else if (current.classList.contains('is--open') === true) {
                    current.classList.remove('is--open');
                    body.classList.remove('has--open-nav');
                } else {
                    current.classList.add('is--open');
                    body.classList.add('has--open-nav');
                }
            }
            e.preventDefault();
        });
    }
}
toggleItem(document.querySelectorAll('.js-toggler'));


// Make "Close" Buttons close the subnav
function navClose(elem) {
    for (var i = 0; i < elem.length; i++) {
        elem[i].addEventListener('click', function(e) {

            const child = this;
            const navItem = child.closest('.c-nav__item');
            const navToggler = navItem.querySelector('.c-nav__link');
            var body = document.querySelector('body');

            navToggler.classList.remove('is--open');
            body.classList.remove('has--open-nav');

            e.preventDefault();
        });
    }
}
navClose(document.querySelectorAll('.js-menuclose'));
